// var Controller = [function(){
    
// }];

function Directive (){
    return {
        // scope: {
            
        // },
        restrict: 'E',
        //controller: Controller,
        //controllerAs: 'vm',
        template: require('./isLoading.jade')
    };
}

export default Directive;


// WEBPACK FOOTER //
// ./app/common/widgets/isLoading.js